// extracted by mini-css-extract-plugin
export default {"productDetailsPage":"styles_productDetailsPage__bB--W"};